"use client";

import React from "react";
import { useNav } from "@/providers/Nav";

interface MainNavGateProps {
  children: React.ReactNode;
}

export default function MainNavGate({ children }: MainNavGateProps) {
  const { showMainNav } = useNav();
  if (!showMainNav) return null;
  return <>{children}</>;
}
